import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import type { XDropdown } from '@adornis/popover/x-dropdown.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';

@customElement('bh-dialog-add-filter')
export class BHDialogAddFilter extends ChemistryLitElement {
  @state() readonly _translation = new TranslationController<BHTranslationDictionary>(this);
  @state() selectedFilter: string | null = null;

  @state() allFilters: any[];

  override render() {
    if (this.allFilters.filter(f => !f.inUse).length === 0) return nothing;
    const dropdown_ref = createRef<XDropdown>();
    return html`
      <tr-button
        icon="filter_alt"
        @click=${async () => {
          this.selectedFilter = null; // reset dialog
          dropdown_ref.value?.toggle();
        }}
        >Filter</tr-button
      >
      <x-dropdown ${ref(dropdown_ref)}>
        <x-flex slot="dropdown-content">
          <x-card>
            <x-flex vertical crossaxis-start ${css({ gap: '7px' })}>
              ${this.selectedFilter === null ? this.renderSelectFilter() : this.renderFilter(dropdown_ref)}
            </x-flex>
          </x-card>
        </x-flex>
      </x-dropdown>
    `;
  }

  renderSelectFilter() {
    const filters = this.allFilters.filter(f => !f.inUse);

    return filters.map(
      filter => html`
        <x-button
          mode="text"
          icon="add"
          class="hover-text-button"
          @click=${async () => {
            this.selectedFilter = filter.key;
          }}
        >
          ${this._translation.translate('FILTER', filter.key)}
        </x-button>
      `,
    );
  }

  renderFilter(dropdown_ref) {
    const options = this.allFilters.find(f => f.key === this.selectedFilter);
    const valueListRef = createRef();
    return html`
      <bh-dialog-select-list
        ${ref(valueListRef)}
        .selectables=${options.selectables}
        .renderString=${options.renderString}
        .value=${options.value}
      ></bh-dialog-select-list>

      <!-- spacer -->
      <x-flex
        ${css({
          height: '1px',
          width: '100%',
          background: this.colors.secondary.shade(100),
        })}
      ></x-flex>

      <x-button
        mode="text"
        class="hover-text-button"
        icon="add"
        @click=${async () => {
          const value = (valueListRef.value?.value?.length ?? 0) === 0 ? undefined : valueListRef.value.value;
          this.dispatchEvent(new CustomEvent('onSave', { detail: { key: options.key, value } }));
          dropdown_ref.value.close();
        }}
      >
        ${this._translation.translate('add')}
      </x-button>

      <x-button mode="text" class="hover-text-button" icon="close" @click=${async () => (this.selectedFilter = null)}>
        ${this._translation.translate('LOGIN_PAGE', 'back')}
      </x-button>
    `;
  }
}
